module.exports = __webpack_public_path__ + "assets-cabinet/img/user.78ea2bee.png";